export enum BankLinesState {
  BankLinesList = 'bankLinesList',
  ConnectBank = 'connectBank',
  Empty = 'empty',
  RenewBankConnection = 'renewBankConnection',
}
